import type { ResumeData } from "@/types/resume";

export interface FontPair {
  id: string;
  label: string;
  headingFont: string;
  bodyFont: string;
  /** Comma-separated Google font families to load for PDF print, or empty. */
  googleFamilies?: string;
  /** DOCX-compatible body font name. */
  docxFont?: string;
}

export const FONT_PAIRS: FontPair[] = [
  { id: "default", label: "Template default", headingFont: "", bodyFont: "" },
  {
    id: "inter-sans",
    label: "Inter (modern sans)",
    headingFont: "'Inter', system-ui, sans-serif",
    bodyFont: "'Inter', system-ui, sans-serif",
    googleFamilies: "Inter:wght@400;500;600;700",
    docxFont: "Inter",
  },
  {
    id: "georgia-serif",
    label: "Georgia (classic serif)",
    headingFont: "Georgia, 'Times New Roman', serif",
    bodyFont: "Georgia, 'Times New Roman', serif",
    docxFont: "Georgia",
  },
  {
    id: "playfair-source",
    label: "Playfair Display + Source Sans",
    headingFont: "'Playfair Display', Georgia, serif",
    bodyFont: "'Source Sans 3', 'Source Sans Pro', system-ui, sans-serif",
    googleFamilies: "Playfair+Display:wght@500;600;700&family=Source+Sans+3:wght@400;600",
    docxFont: "Source Sans Pro",
  },
  {
    id: "jetbrains-mono",
    label: "JetBrains Mono (technical)",
    headingFont: "'JetBrains Mono', 'Fira Code', monospace",
    bodyFont: "'JetBrains Mono', 'Fira Code', monospace",
    googleFamilies: "JetBrains+Mono:wght@400;500;700",
    docxFont: "Consolas",
  },
  {
    id: "lora-nunito",
    label: "Lora + Nunito Sans",
    headingFont: "'Lora', Georgia, serif",
    bodyFont: "'Nunito Sans', system-ui, sans-serif",
    googleFamilies: "Lora:wght@500;600;700&family=Nunito+Sans:wght@400;600",
    docxFont: "Nunito Sans",
  },
];

export function getFontPair(id?: string): FontPair {
  return FONT_PAIRS.find((f) => f.id === id) || FONT_PAIRS[0];
}

/** Returns a CSS fontFamily for body text. Falls back to provided default. */
export function bodyFont(data: ResumeData, fallback: string): string {
  const pair = getFontPair(data.fontFamily);
  return pair.bodyFont || fallback;
}

/** Returns a CSS fontFamily for headings. Falls back to provided default. */
export function headingFont(data: ResumeData, fallback: string): string {
  const pair = getFontPair(data.fontFamily);
  return pair.headingFont || fallback;
}